<template>
    <div v-if="!isLoadingAppointment" class="appointment form-dimensioning">

        <div :class="{
                'appointment__book-wrapper': true,
                'appointment__book-wrapper--disabled': bookingDisabled,
            }"
        >
            <div class="appointment__chose-date">
                <div
                    @click="() => handleDateClicked(index)"
                    v-for="(dateEntry, index) in appointment.dates"
                    :key="`appointment-date-${index}`"
                    :class="{
                        'appointment__calendar-item': true,
                        'appointment__calendar-item--active': activeDateIndex == index,
                    }"
                >
                    <span class="appointment__calendar-item-day">{{ dateEntry.date }}</span>
                    <span class="appointment__calendar-item-weekday">{{ getWeekday(dateEntry.day) }}</span>
                </div>
            </div>

            <div class="appointment__book-date">
                <template v-if="activeDateIndex !== null">
                    <div class="appointment__headline">
                        <span class="appointment__headline-day">{{ getActiveDate.date }}</span>
                        <span class="appointment__headline-weekday">{{ getWeekday(getActiveDate.day) }}</span>
                    </div>
                    <p class="appointment__dates-headline">Verfügbare Termine</p>
                    <div class="appointment__times">
                        <span
                            @click="() => handleTimeClicked(timeIndex, timeData.timestamp)"
                            v-for="(timeData, timeIndex) in getActiveDate.times"
                            :key="`appointment-time-${timeIndex}`"
                            :class="{
                                'appointment__time': true,
                                'appointment__time--smaller': true,
                                'appointment__time--active': activeTimeIndex !== null && activeTimeIndex.indexOf(timeIndex) !== -1,
                                'appointment__time--user-booked': appointmentIsReserved(timeData.timestamp),
                                'appointment__time--appointment': isType(timeData.timestamp, 'appointmentKam'),
                                'appointment__time--blocked-date': isType(timeData.timestamp, 'blockedAppointment'),
                            }">
                                <span class="appointment__info" v-if="tooltipContent(timeData.timestamp)">
                                    <span>{{ timeData.time }}</span>
                                    <div class="appointment__info-content">
                                        <div v-if="tooltipContent(timeData.timestamp).participant">
                                            <span class="appointment__info-label">{{ t('mit') }}:</span>
                                            <span class="appointment__info-text">{{ tooltipContent(timeData.timestamp).participant }}</span>
                                        </div>

                                        <div v-if="tooltipContent(timeData.timestamp).plusone">
                                            <span class="appointment__info-label">{{ t('plus-one') }}:</span>
                                            <span class="appointment__info-text">{{ tooltipContent(timeData.timestamp).plusone }}</span>
                                        </div>

                                        <div v-if="tooltipContent(timeData.timestamp).note">
                                            <span class="appointment__info-label">{{ t('fragen-an-den-account-manager') }}:</span>
                                            <span class="appointment__info-text" v-html="tooltipContent(timeData.timestamp).note" />
                                        </div>

                                        <button-element
                                            @click="() => cancelAppointment(timeData.timestamp)"
                                            :disabled="isCanceling"
                                            :button="{
                                                'label': t('termin-stornieren')
                                            }"
                                        >
                                            <span slot="icon" v-if="isBooking">
                                                <loader-element />
                                            </span>
                                        </button-element>
                                    </div>
                                </span>
                                <span v-else>{{ timeData.time }}</span>
                            </span>

                    </div>
                    <div class="appointment__buttons">
                        <button-element
                            @click="saveAppointments"
                            :disabled="!activeTimeIndex.length || isBooking"
                            :button="{
                                'label': t('termine-aktualisieren')
                            }"
                        >
                            <span slot="icon" v-if="isBooking">
                                <loader-element />
                            </span>
                        </button-element>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import {
    APPOINTMENT_FETCH_NS,
    APPOINTMENT_BLOCK_NS,
    APPOINTMENT_CANCEL_KAM_NS,
} from "@/store/actions.type";


import ImageElement from '@/components/elements/ImageElement.vue';
import SelectElement from '@/components/elements/form/SelectElement.vue';
import LoaderElement from '@/components/elements/LoaderElement.vue';
import TooltipElement from '@/components/elements/TooltipElement.vue';

export default {
    name: 'BlockAppointmentsElement',
    components: {
        ImageElement,
        SelectElement,
        LoaderElement,
        TooltipElement,
    },
    props: {
        appointment: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters('uitexts', {
            t: 't',
        }),

        ...mapGetters('me', {
            isLoadingMe: 'isLoading',
            me: 'getMe',
        }),

        ...mapGetters('appointment', {
            isLoadingAppointment: 'isLoading',
            isBooking: 'isBooking',
            isCancelling: 'isCancelling',
            appointments: 'getAppointments',
            appointmentTypeMap: 'getAppointmentTypeMap',
            appointmentData: 'getAppointmentData',
            getKam: 'getKam',
        }),

        getActiveDate() {
            return this.activeDateIndex !== null ? this.appointment.dates[this.activeDateIndex] : null;
        },

        buttonsDisabled() {
            return this.bookingDisabled || this.isBooking;
        },
    },

    data: () => {
        return {
            activeDateIndex: null,
            activeTimeIndex: [],
            bookingDisabled: false,
        }
    },

    async created() {
        await store.dispatch(APPOINTMENT_FETCH_NS, this.me.email);
    },

    mounted() {

    },

    methods: {
        handleClose() {
            this.$emit('close');
        },

        handleDateClicked(index) {
            if (!this.buttonsDisabled) {
                this.activeTimeIndex = [];
                this.activeDateIndex = index;
            }
        },

        handleTimeClicked(index, timestamp) {
            if (!this.buttonsDisabled && !this.appointmentIsReserved(timestamp)) {
                const indexOfIndex = this.activeTimeIndex.indexOf(index);
                if (indexOfIndex !== -1) {
                    this.activeTimeIndex.splice(indexOfIndex, 1);
                } else {
                    this.activeTimeIndex.push(index);
                }

            }
        },

        async cancelAppointment(timestamp) {

            if (this.appointmentData.hasOwnProperty(timestamp)) {
                const data = this.appointmentData[timestamp];

                const bookingResult = await store.dispatch(APPOINTMENT_CANCEL_KAM_NS, {
                    kam: this.me.email,
                    appointment: timestamp,
                    action: 'guestmanagement/appointment/cancel-by-kam'
                });
            }
        },

        async saveAppointments() {

            if (!this.buttonsDisabled) {

                const unblockAppointments = [];
                const blockedAppointments = [];

                this.getActiveDate.times.forEach((time, index) => {
                    if (this.activeTimeIndex.indexOf(index) !== -1) {
                        if (this.isType(time.timestamp, 'blockedAppointment')) {
                            unblockAppointments.push({
                                appointment: time.timestamp
                            });
                        } else {
                            blockedAppointments.push({
                                appointment: time.timestamp,
                                type: 'blockedAppointment'
                            });
                        }
                    }
                });

                const bookingResult = await store.dispatch(APPOINTMENT_BLOCK_NS, {
                    kam: this.me.email,
                    blockedAppointments,
                    unblockAppointments,
                    action: 'guestmanagement/appointment/block'
                });

                this.activeTimeIndex = [];
            }
        },

        appointmentIsReserved(timestamp) {
            return this.appointments && this.appointments.indexOf(timestamp) !== -1;
        },

        getWeekday(day) {
            return [
                'Montag',
                'Dienstag',
                'Mittwoch',
                'Donnerstag',
                'Freitag',
                'Samstag',
                'Sonntag',
            ][parseInt(day) - 1];
        },

        isType(timestamp, type) {
            return this.appointmentTypeMap.hasOwnProperty(timestamp) && this.appointmentTypeMap[timestamp] == type;
        },

        tooltipContent(timestamp) {

            if (this.appointmentData.hasOwnProperty(timestamp)) {
                return this.appointmentData[timestamp];
            }

            return null;
        },
    }
}
</script>
